export  class  ApiUrlsConstant {
    public static readonly clientTemplateAPI = 'cp/api/getClientTemplate';
    public static readonly countryAPI = 'bocm/api/country'; 
    public static readonly currencyAPI = 'bocm/api/currency/GetCurrencyDetails';   
    public static readonly saveClientAPI = 'api/clientportal/save';   
    public static readonly getTemplateAPI = 'api/gettemplates';   
    public static readonly firstTimelogin = 'api/Login/FirstLogin';   
    public static readonly changePassword = 'api/ChangePassword/ChangePassword';   
    public static readonly login = 'api/Login'; 
    public static readonly clientPaymentTemplate = 'cp/api/getCLPaymentTempConfig'; 
    public static readonly saveclientPayment = 'api/ClientPayment/SaveClientPaymentDetails'; 
    public static readonly checkOtpNo = 'api/CheckOtp'; 
    public static readonly resendOtp = 'api/CheckOtp/resendOtp'; 
    public static readonly getCatalogueCountry = 'api/CatalogueView/getCountries'; 
    public static readonly getCatalogueView = 'api/CatalogueView/getCatalogueView'; 
    public static readonly forgotPassword = 'api/ForgotPassword'; 
    public static readonly generateExcel ='api/clientportal/generateExcel';
    public static readonly ordersUpload= 'api/clientportal/ordersUpload';
    public static readonly webFormOrdersSave= 'api/clientportal/webFormOrderPlace';
     
}
export class FileSettings {
    public static readonly fileUploadMaxSize = 1024 * 1024 * 5;
    public static readonly allowedExcelExtensions = ['xlsx', 'xls'];
    public static readonly allowedZipExtensions = ['zip', 'rar'];
    public static readonly fileUploadMaxFiles = 1;
    public static readonly fileUploadErrorMessage = 'File size should be less than 5MB';
    public static readonly fileUploadErrorFileTypeMessage = 'Only image files are allowed';
    public static readonly fileUploadErrorMaxFilesMessage = 'Only one file is allowed';
}
